import { UserContact } from '@uplift/types';
import { restClient } from '../client';
import snakecaseKeys from 'snakecase-keys';

export type AuthLoginInput = {
  username: string;
  password: string;
  redirect_to?: string;
  device_token?: string;
};

export const enum AuthStatus {
  MFA_REQUIRED = 'MFA_REQUIRED',
  REDIRECT = 'REDIRECT',
  MFA_CHALLENGE = 'MFA_CHALLENGE'
}

export type AuthLoginError = {
  error: string;
  message: string;
};

export type AuthLoginRedirectOutput = {
  id: string;
  status: AuthStatus.REDIRECT;
  redirect_url: string;
  code: string;
};

export type AuthImpersonateOutput = {
  id: string;
  status: AuthStatus.REDIRECT;
  redirect_url: string;
  code: string;
};

export type AuthLoginOutput =
  | {
    id: string;
    email: string;
    status: AuthStatus.MFA_CHALLENGE | AuthStatus.MFA_REQUIRED;
    contacts: UserContact[];
    device_token: string;
    request_id: string;
  }
  | AuthLoginRedirectOutput
  | AuthLoginError
  ;

export const authLogin = (data: AuthLoginInput) => {
  return restClient.request<AuthLoginOutput>('/auth/login', { method: 'POST', data });
};


export const authUpdateLastLogin = () => {
  return restClient.request<{ last_login: string }>('/api/v1/auth/update_last_login', { method: 'POST' });
};


export const authImpersonate = (userId: string) => {
  return restClient.request<AuthImpersonateOutput | AuthLoginError>('/auth/impersonate', { method: 'POST', data: { user_id: userId } });
};

export const authExchangeCode = (code: string) => {
  return restClient.request<{ access_token: string; refresh_token: string }>('/auth/exchange-code', { method: 'POST', data: { code } });
};

export type AuthSendOTPInput = {
  useAccountEmail: boolean;
  contactId?: string;
  requestId: string;
};

export const authSendOTP = (userId: string, body: AuthSendOTPInput) =>
  restClient.request(`/api/v1/user/${userId}/send_otp_2fa`, {
    method: 'POST',
    data: snakecaseKeys(body)
  });

export type AuthVerifyOTPInput = AuthSendOTPInput & {
  otp: string;
  deviceToken: string;
  snooze_2fa: boolean;
};

export const authVerifyOTP = (userId: string, body: AuthVerifyOTPInput) =>
  restClient.request<{
    data: {
      redirect_url: string;
      code: string;
    };
  }>(`/api/v1/user/${userId}/verify_2fa`, {
    method: 'POST',
    data: snakecaseKeys(body)
  });
